// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/VEClim-drop.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.leaflet-container img.leaflet-tile {
	mix-blend-mode: normal !important;
}
/* .leaflet-tile-container.leaflet-zoom-animated
	> .leaflet-tile.leaflet-tile-loaded {
	opacity: 0.6 !important;
} */

.leaflet-attribution-flag {
	display: none !important;
}



.leaflet-control-attribution.leaflet-control {
	right: 50vw !important;
	transform: translateX(50%);
	left: auto !important;
}
.leaflet-sbs-divider {
	pointer-events: auto;
}
#map1 {
	cursor: default !important;
	/* transform:rotate(180deg); */
}
#coordinates {
	display: none;
	justify-content: center;
	align-items: flex-end;
	text-align: center;
	position: absolute;
	z-index: 5000;
	font-size: 0.7rem;
	right: 0px;
	top: 45px;
	width: 50px;
	height: 60px;
	color: white;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-position: 0px 14px;
	background-repeat: no-repeat;
}
.highlight-marker {
	background-color: transparent;
	border: 2px solid red;
	border-radius: 0%;
	/* width: 1rem; */
	/* height: 1rem; */
	cursor: default;
	z-index: 3002;
}
.marker-red {
	background-color: transparent;
	border: 2px solid red;
	border-radius: 0%;
	/* width: 1rem; */
	/* height: 1rem; */
	color: green;
	cursor: default;
	z-index: 3002;
}

@media (min-width: 500px) {
	#coordinates {
		display: none;
		justify-content: center;
		align-items: flex-end;
		text-align: center;
		position: absolute;
		z-index: 5000;
		font-size: 1rem;
		right: 0px;
		top: 55px;
		width: 70px;
		height: 85px;
		color: white;
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
		background-repeat: no-repeat;
		background-position: 0px 20px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/map/MapComponent/mapComponent.css"],"names":[],"mappings":";AACA;CACC,iCAAiC;AAClC;AACA;;;GAGG;;AAEH;CACC,wBAAwB;AACzB;;;;AAIA;CACC,sBAAsB;CACtB,0BAA0B;CAC1B,qBAAqB;AACtB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,0BAA0B;CAC1B,8BAA8B;AAC/B;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,qBAAqB;CACrB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,iBAAiB;CACjB,UAAU;CACV,SAAS;CACT,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,yDAA2D;CAC3D,6BAA6B;CAC7B,4BAA4B;AAC7B;AACA;CACC,6BAA6B;CAC7B,qBAAqB;CACrB,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,aAAa;AACd;AACA;CACC,6BAA6B;CAC7B,qBAAqB;CACrB,iBAAiB;CACjB,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,aAAa;AACd;;AAEA;CACC;EACC,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yDAA2D;EAC3D,4BAA4B;EAC5B,6BAA6B;CAC9B;AACD","sourcesContent":["\n.leaflet-container img.leaflet-tile {\n\tmix-blend-mode: normal !important;\n}\n/* .leaflet-tile-container.leaflet-zoom-animated\n\t> .leaflet-tile.leaflet-tile-loaded {\n\topacity: 0.6 !important;\n} */\n\n.leaflet-attribution-flag {\n\tdisplay: none !important;\n}\n\n\n\n.leaflet-control-attribution.leaflet-control {\n\tright: 50vw !important;\n\ttransform: translateX(50%);\n\tleft: auto !important;\n}\n.leaflet-sbs-divider {\n\tpointer-events: auto;\n}\n#map1 {\n\tcursor: default !important;\n\t/* transform:rotate(180deg); */\n}\n#coordinates {\n\tdisplay: none;\n\tjustify-content: center;\n\talign-items: flex-end;\n\ttext-align: center;\n\tposition: absolute;\n\tz-index: 5000;\n\tfont-size: 0.7rem;\n\tright: 0px;\n\ttop: 45px;\n\twidth: 50px;\n\theight: 60px;\n\tcolor: white;\n\tbackground-image: url(\"/src/assets/images/VEClim-drop.svg\");\n\tbackground-position: 0px 14px;\n\tbackground-repeat: no-repeat;\n}\n.highlight-marker {\n\tbackground-color: transparent;\n\tborder: 2px solid red;\n\tborder-radius: 0%;\n\t/* width: 1rem; */\n\t/* height: 1rem; */\n\tcursor: default;\n\tz-index: 3002;\n}\n.marker-red {\n\tbackground-color: transparent;\n\tborder: 2px solid red;\n\tborder-radius: 0%;\n\t/* width: 1rem; */\n\t/* height: 1rem; */\n\tcolor: green;\n\tcursor: default;\n\tz-index: 3002;\n}\n\n@media (min-width: 500px) {\n\t#coordinates {\n\t\tdisplay: none;\n\t\tjustify-content: center;\n\t\talign-items: flex-end;\n\t\ttext-align: center;\n\t\tposition: absolute;\n\t\tz-index: 5000;\n\t\tfont-size: 1rem;\n\t\tright: 0px;\n\t\ttop: 55px;\n\t\twidth: 70px;\n\t\theight: 85px;\n\t\tcolor: white;\n\t\tbackground-image: url(\"/src/assets/images/VEClim-drop.svg\");\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-position: 0px 20px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
